export default __webpack_public_path__ + "images/353d892fc6ba54d9252e5f7a2e5b9955.svg";